import useInputForm, {
	UseInputFormResult,
	UseInputFormParameters,
} from './UseInputForm';
import useInputFormCache, {
	UseInputFormCacheResult,
	UseInputFormCacheParameters,
} from './UseInputFormCache';

// Export hook calls.
export {
	useInputForm,
	useInputFormCache,
};

// Export hook results.
export {
	UseInputFormResult,
	UseInputFormCacheResult,
};

// Export hook parameters.
export {
	UseInputFormParameters,
	UseInputFormCacheParameters,
};
